/** Đọc SSE của POST /mvp/setup-device-assistant khi response_mode là streaming. */

export function createAssistantSseReader({ onAudio, onDone, onError }) {
  let buffer = '';
  let settled = false;

  const finish = (kind, payload) => {
    if (settled) return;
    settled = true;
    if (kind === 'done' && typeof onDone === 'function') onDone(payload || {});
    else if (typeof onError === 'function') onError(payload || {});
  };

  const consume = (block) => {
    let eventName = 'message';
    const dataLines = [];
    block.split(/\r?\n/).forEach((line) => {
      if (line.startsWith('event:')) eventName = line.slice(6).trim();
      else if (line.startsWith('data:')) dataLines.push(line.slice(5).trim());
    });
    if (!dataLines.length) return;
    let payload = null;
    try {
      payload = JSON.parse(dataLines.join('\n'));
    } catch (err) {
      return;
    }
    if (eventName === 'audio' && typeof onAudio === 'function') onAudio(payload);
    else if (eventName === 'done') finish('done', payload);
    else if (eventName === 'error') finish('error', payload);
  };

  return {
    push(text) {
      buffer += text;
      const parts = buffer.split(/\r?\n\r?\n/);
      buffer = parts.pop();
      parts.forEach(consume);
    },
    end() {
      if (buffer.trim()) consume(buffer);
      buffer = '';
      finish('error');
    },
    get settled() {
      return settled;
    },
  };
}
